import { render, staticRenderFns } from "./FactoringsControllers.vue?vue&type=template&id=2e122171&scoped=true&"
import script from "./FactoringsControllers.vue?vue&type=script&lang=js&"
export * from "./FactoringsControllers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e122171",
  null
  
)

export default component.exports